<template>
    <div class="serviceListContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>视频号服务</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 列表 -->
        <div class="serviceListBox">
            <service :serviceList="serviceList.list"></service>
            <div class="pageBox">
                <el-pagination background layout="prev, pager, next" :page-size="20" :total="serviceList.count" @current-change="currentPage"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
     export default{
        data(){
            return{
                page: 1,
                serviceList: {}
            }
        },
        mounted(){
            this.getServiceList()
        },
        methods: {
            // 获取服务列表
            getServiceList(){
                this.request.get("index/fuwu/fuwuall",{
                    params:{
                        page: this.page,
                        pagesize: '20'
                    }
                })
                .then(res=>{
                    this.serviceList = res.data
                })
            },
            // 翻页
            currentPage(e){
                this.page = e
                this.getServiceList()
            },
        }
    }
</script>
<style lang="less" scoped>
    .serviceListContent{
        background: #FAFBFC;
        padding-bottom: 50px;
        .serviceListBox{
            width: 1164px;
            padding: 28px 18px;
            margin: 0 auto;
            background: #fff;
            border-radius: 10px;
        }
    }
</style>